var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],class:_vm.cssClass,attrs:{"data-container":"body","data-placement":_vm.tooltipPlacement,"title":_vm.title}},[_c('icon',{attrs:{"name":_vm.iconName}}),_vm._v(" "),(_vm.isValuePresent)?_c('span',{staticClass:"stat-value"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17f8081d","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./groups/components/item_stats_value.vue
// module id = null
// module chunks = 